import { render, staticRenderFns } from "./IframePageView.vue?vue&type=template&id=4dbbc00e"
import script from "./IframePageView.vue?vue&type=script&lang=js"
export * from "./IframePageView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dbbc00e')) {
      api.createRecord('4dbbc00e', component.options)
    } else {
      api.reload('4dbbc00e', component.options)
    }
    module.hot.accept("./IframePageView.vue?vue&type=template&id=4dbbc00e", function () {
      api.rerender('4dbbc00e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layouts/IframePageView.vue"
export default component.exports